module.exports = __webpack_public_path__ + "img/continue.4309699b.png";